import clsx from 'clsx';

interface ITextareaProps {
  // ADDITIONAL PROPS:
  className?: string;
  variant?: 'standard' | 'outlined';
  rounded?: boolean;
  error?: boolean | string;
  // BASE TEXTAREA PROPS:
  placeholder?: string;
  disabled?: boolean;
  value?: string;
  onChange?: (value: string) => void;
}

export const Textarea = (props: ITextareaProps) => {
  return (
    <textarea
      className={clsx(
        'min-h-[270px] w-full resize-none appearance-none bg-transparent px-5 py-2.5 text-xs font-medium text-[#efefef] uppercase placeholder:text-xs placeholder:text-[#929292] disabled:placeholder:text-[#666]',
        (!props.variant || props.variant === 'standard') && ['border-b border-b-[#929292]', props.error && '!border-b-[#e42d34]'],
        props.variant === 'outlined' && ['border border-[#929292]', props.error && '!border-[#e42d34]'],
        props.error && '!text-[#e42d34] placeholder:!text-[#e42d34]',
        props.rounded && '!rounded-sm',
        props.className,
      )}
      placeholder={props.placeholder}
      disabled={props.disabled}
      value={props.value}
      onChange={(e) => props.onChange?.(e.target.value)}
    />
  );
};
